/*
 * fn: setAdCookie
 *
 * Sets a the ad cookie
 *
 */
import { COOKIE_MAX_AGE } from '@/defs/cookie'

import { setCookie } from './setCookie'

export const setAdCookie = (enable: boolean) => {
  const ad = enable ? 'on' : 'off'
  document.documentElement.dataset.ad = ad
  setCookie('ad', ad, { maxAge: COOKIE_MAX_AGE })
}
